export default abstract class RecaptchaInitializerBase {

    public prepareTextContainer(jq: JQueryStatic, container: JQuery) {
        const captchaTextElement = jq("#recaptcha-message-element");
        const captchaBlockContainer = container.find(".captcha-elements-container-selector");
        const textContainer = jq(`<div class="p-2 recaptcha-text"> ${captchaTextElement.text()} </div>`);
        captchaBlockContainer
            .empty().append(textContainer);
        if (captchaBlockContainer.length) {
            captchaBlockContainer.removeClass("d-none");
        }
    }
}
